/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReorderComponentsRequest = zod
	.object({
		component_ids: zod.array(zod.string()).describe('Ordered list of component IDs')
	})
	.describe('Request body for reordering components');

export type ReorderComponentsRequest = zod.input<typeof ReorderComponentsRequest>;
export type ReorderComponentsRequestOutput = zod.output<typeof ReorderComponentsRequest>;
